import { IRootState } from "app/model"
import React from "react"
import { connect } from "react-redux"
import { MyCampaignItemsPage } from "./misc/MyCampaignItemsPage"

interface IMyCampaignsPageProps {
  isLoading: boolean
  hasLoadingError: boolean
}

const MyCampaignsPageFn = ({ isLoading, hasLoadingError }: IMyCampaignsPageProps): JSX.Element => (
  <MyCampaignItemsPage hasLoadingError={hasLoadingError} isLoading={isLoading} isForecast={false} isDspDeal={false} />
)

export const MyCampaignsPage = connect(
  (state: IRootState): IMyCampaignsPageProps => ({
    isLoading: state.app.isInitializating,
    hasLoadingError: state.app.hasInitError
  })
)(MyCampaignsPageFn)
